// extracted by mini-css-extract-plugin
export default {"agreeBtn":"Message_agreeBtn__3uT-Y","btnsContainer":"Message_btnsContainer__y2+n2","subTitle":"Message_subTitle__YbLa2"};